<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.certificateCode" style="width: 150px;" size="mini"
                        placeholder="劵码" clearable></el-input>
                    <el-input v-model="formDatas.certificateName" style="width: 150px;" size="mini"
                        placeholder="劵码名称" clearable></el-input>
                    <el-select v-model="formDatas.lookStatus" placeholder="请选择状态" style="width: 120px;" size="mini"
                        clearable @change="partserch">
                        <el-option label="未查看" :value="0"></el-option>
                        <el-option label="已查看" :value="1"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="warning" size="mini" icon="el-icon-download" @click="handleExport"
                        style="margin-left: 10px">导出</el-button>
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjefCertificateRecordLookList } from "../../api/api";
export default {
    name: "CertificateRecordLook",
    components: {},
    data() {
        return {
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "certificateCode",
                    key: "certificateCode",
                    title: "劵码",
                    align: "center",
                    width: 180,
                },
                {
                    field: "certificateName",
                    key: "certificateName",
                    title: "劵码名称",
                    align: "center",
                },
                {
                    field: "certificateAmount",
                    key: "certificateAmount",
                    title: "劵码金额",
                    align: "center",
                },
                {
                    field: "lookUserName",
                    key: "lookUserName",
                    title: "查看人",
                    align: "center",
                },
                {
                    field: "lookTime",
                    key: "lookTime",
                    title: "查看时间",
                    width: 160,
                    align: "center",
                },
                {
                    field: "lookStatus",
                    key: "lookStatus",
                    title: "状态",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.lookStatus == 0) {
                            return '未查看'
                        } else if (row.lookStatus == 1) {
                            return '已查看'
                        } else {
                            return ''
                        }
                    },
                },
                {
                    field: "createTime",
                    key: "g",
                    title: "创建时间",
                    width: 160,
                    align: "center",
                },
            ],
            tableData: [],
            formDatas: {
                currentPage: 1,
                pageSize: 10,
            },
            totalCount: 100,
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        openLoading() {
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        handleExport() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-certificate-record-look/exportAjefCertificateRecordLook',
                data: s,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'user': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '券码查看记录.xlsx');
                    a.click();
                    that.$message({
                        message: "导出成功",
                        type: "success"
                    });
                }
            })
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            getAjefCertificateRecordLookList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjefCertificateRecordLookList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
        getList() {
            getAjefCertificateRecordLookList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
